import { OperationRequestData } from "../../data/operationRequestData";
import { OperationInitTypes } from "../../models/enums/operationInitTypes";
import { CatalogOperationModel } from "../../models/operations/catalogOperationModel";
import { OperationPropertyModel } from "../../models/operations/operationPropertyModel";
import { DeclarationPropertyValueData } from "../../data/declarationPropertyValueData";
import { ConfigStore } from "../../store/modules/config";
import { PersonStore } from "../../store/modules/person";
import { ContractsStore } from "../../store/modules/contracts";
import { ActionStateEnum } from "../../models/enums/operStateEnum";
import { inject, injectable } from "inversify";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { OperationDetailsModel } from "../../models/operations/operationDetailsModel";
import IAlertService from "../alert/IAlertService";
import { OperationsApi } from "../api/OperationsApi";
import router from "@/router";
import { TemplatesApi } from "../api/TemplatesApi";
import { DiTokens } from "../diTokens";
import IErrorService from "../error/IErrorService";
import currencyFilter from "../../filters/currency.filter";
import IAuthService from "../../services/auth/IAuthService";
import IOperationsHistoryService from "../../services/history/IOperationsHistoryService";
import { OperationModel } from "../../models/operations/operationModel";
import { container } from "@/inversify.config";
import BaseOperationService from "./BaseOperationService";
import i18n from "@/i18n";
import storeAccessor from "../../store/storeAccessor";
import { getModule } from "vuex-module-decorators";
import { isStringEmpty } from "fs-pb-vue2/utilities";

/**Сервис проведения операций */
@injectable()
export default class CatalogOperationService extends BaseOperationService {
  constructor(
    @inject(DiTokens.AlertService) public alertService: IAlertService,
    @inject(DiTokens.ErrorService) public errorService: IErrorService
  ) {
    super(alertService, errorService);
  }

   /**Стор настроек */
   get configStore(): ConfigStore {
    return getModule(ConfigStore, storeAccessor.store);
  }

   /**Стор счетов */
   get contractsStore(): ContractsStore {
    return getModule(ContractsStore, storeAccessor.store);
  }

   /**Стор пользователей */
   get personStore(): PersonStore {
    return getModule(PersonStore, storeAccessor.store);
  }

  // get notCriticalErrors(): any {
  //   return Object.keys(i18n.t('main.operations.notCriticalErrors')).reduce((acc, it) => {
  //     acc.push(i18n.t(`main.operations.notCriticalErrors.${it}`)); 
  //     return acc; 
  //   }, []);
  // }

  private authService = container.get<IAuthService>(DiTokens.AuthService);

  private detailsService = container.get<IOperationsHistoryService>(DiTokens.OperationsHistoryService);
  /**
   * Инициализация операции
   * @param initData Данные для инициализации
   * */
  public async init(
    id: number,
    type: OperationInitTypes,
    addInitData: any = {}
  ): Promise<CatalogOperationModel> {
    let template: OperationRequestData | null = null;
    let catalogId = id;
    let caption: string = "";
    let model: CatalogOperationModel = new CatalogOperationModel();
    if (type != OperationInitTypes.New) {
      if (type == OperationInitTypes.ByTemplate) {
        template = await TemplatesApi.getTemplateAsync(id);
        caption = template?.templateName as string;
      } else if (type == OperationInitTypes.Repeat) {
        template = await OperationsApi.getRepeatOperationAsync(id);
        caption = template?.caption as string;
      }
      catalogId = parseInt(template?.respondentCode as string);
    }

    try {
      const declaration = await OperationsApi.getDeclarationAsync(catalogId, this.configStore.apiData.OperationCodeOfToOtherContractByCard, this.configStore.apiData.OperationCodeOfToExt);
      const respondent = await OperationsApi.getRespondentAsync(catalogId);

      declaration.Caption = caption ? caption : respondent.Caption;

      //declaration.Description = respondent.Description;
      model = new CatalogOperationModel(
        declaration,
        this.contractsStore.contracts,
        template,
        addInitData,
        this.configStore
      );
      model.Description = declaration.Description;
      model.Picture = respondent.Picture;

      if (type == OperationInitTypes.New && addInitData.QRcode) {
        //Вызываем assign.
        for (let i = 0; i < model.Properties.length; i++) {
          const prop = model.Properties[i];
          // Загрузка значения по умолчанию.
          if (
            prop.Declaration.Default &&
            !isStringEmpty(prop.Declaration.Default)
            && prop.Declaration.Assign
          ) {
            model = await this.assignRequest(prop.Declaration.Name, model);
          }
        }
      } else if (type == OperationInitTypes.New) {
        //Вызываем assign.
        for (let i = 0; i < model.Properties.length; i++) {
          const prop = model.Properties[i];
          if (id.toString() === this.configStore.apiData.OperationCodeOfMe2MeOperation && prop.Declaration.Name == 'contract') {
            const ac: any = this.contractsStore.contracts.getContractByRefId(this.personStore.personInfo.Data.DefaultInAccount);
            prop.Value = new DeclarationPropertyValueData(
              this.personStore.personInfo.Data.DefaultInAccount,
              `${
                ac?.Data?.Alias.trim() === ""
                  ? ac?.Data?.MainAccount.substring(0, 5) +
                    "*" +
                    ac?.Data?.MainAccount.substring(16, 4)
                  : ac?.Data?.Alias
              } - ${
                ac?.Data?.ContractType == 5
                  ? ac?.DepositSum
                  : ac?.DisposableLimit
              } ${currencyFilter(ac?.Data?.CurrencyCharCode)}`,
              ''
            )
            prop.Declaration.Default = prop.Value;
            prop.Values.push(prop.Value);
          }
          if (Object.keys(addInitData).includes(prop.Declaration.Name)
            && addInitData[prop.Declaration.Name] !== prop.Value
            && prop.Declaration.Default
          ) {
            prop.setProperty(prop.Declaration.Default);
          }
          if (!Object.keys(addInitData).includes(prop.Declaration.Name) && prop.Declaration.Type === DeclarationPropertiesTypes.UserAccount && prop.Declaration.Name == 'contract') {
            const defaulAccOut: string = this.personStore.personInfo.Data.DefaultOutAccount;
            if (defaulAccOut && prop.Values.find((val: DeclarationPropertyValueData) => val.Key === defaulAccOut))
              prop.Declaration.Default = defaulAccOut;
            else
              prop.Declaration.Default = prop.Values[0].Key;
            if (prop.Declaration.Default)
              prop.setProperty(prop.Declaration.Default);
          }
          // Загрузка значения по умолчанию.
          if (
            prop.Declaration.Default &&
            !isStringEmpty(prop.Declaration.Default)
            && prop.Declaration.Assign
          ) {
             model = await this.assignRequest(prop.Declaration.Name, model);
          }
        }
      } else {
        await model.setOperationFromRequest(template, true, true);
      }

      return model;
    } catch(e: any) {
      console.log(e);
      if (model.Properties.length === 0 || !model)
        router.go(-1);
      await this.errorService.errorHandler(e, false, true, "");
    }
    return model;
  }

  /**
   * Обработка execute
   */
  public async execute(model: OperationModel): Promise<OperationModel> {
    try {
      model.ActionStateText = "";
      let ord: OperationRequestData = await model.createOperationRequest();
      ord.verificationCode = model.VerifyCode;
      ord.operationId = model.OperationId;
      ord = await OperationsApi.executeOperationSendAsync(ord);

      if(ord.message)
        await this.alertService.info(ord.message, false);

      model.setOperationFromRequest(ord, false);
      model.RequestState = ord.requestState;
      model = await this.analyzeState(model, ord);
    } catch (e) {
      if (
        e.message.includes("Зафиксирован подбор кода подтверждения!")
      ) {
        this.alertService.clear();
        await this.errorService.errorHandler(e, false, true, "");
        this.authService.logout();
      } else if (
        !e.message.includes("Код подтверждения просрочен или введен неверно")
      ) {
        const dets: OperationDetailsModel = await this.detailsService.getOperationDetails({ Id: model.OperationId, ReferenceId: "" });
        if (dets.RequestData && (dets.RequestData.serverErrorRequestState == 1 || dets.RequestData.serverErrorRequestState == 2)) {
          model.RequestState = dets.RequestData.serverErrorRequestState;
          model = await this.analyzeState(model, dets.RequestData);
          return model;
        } else {
          router.push('/payments');
        }
        await this.alertService.error('Неожиданный разрыв соединения! <br/> Проверьте состояние в истории операций.');
      } else
        await this.errorService.errorHandler(e, false, true, "");
      model.ActionStateText = e.message;
    }
    return model;
  }


  /**
   * Обработка prepare
   */
  public async prepare(model: CatalogOperationModel): Promise<OperationModel> {
    try {
      model.ActionStateText = "";
      let ord: OperationRequestData = await model.createOperationRequest();
      if (model.operationStage === 0) {
        ord.setProperty('operationStage', '0', DeclarationPropertiesTypes.Int);
      }
      if (model.NeedCompletePrepare && model.NeedCompletePrepare.acceptProperty == '0') {
        ord.setProperty(model.NeedCompletePrepare.propertyName, '0', DeclarationPropertiesTypes.String);
      }
      ord = await OperationsApi.prepareOperationSendAsync(ord);

      if(ord.message)
        await this.alertService.info(ord.message, false);

      if (ord.NeedAcceptUri && ord.NeedAcceptProperty) {
        model.NeedCompletePrepare = null;
        if (ord.NeedAcceptMessage.length) {
          model.NeedCompletePrepare = {
            acceptUrl: ord.NeedAcceptUri,
            acceptMessage: ord.NeedAcceptMessage,
            acceptProperty: '1',
            propertyName: ord.NeedAcceptProperty
          };
        } else {
          //window.open(ord.NeedAcceptUri, '_blank');
          window.open(ord.NeedAcceptUri, "EsiaPermission", "width=600,height=800,left=0,top=0,menubar=no,toolbar=no,location=no");
        }
      }

      model.setOperationFromRequest(ord, false);
      const propsHasErrors: boolean = model.Properties.some((prop: any) => prop.errorText.length > 0 && prop.Declaration.View === 0);
      if (propsHasErrors) {
        model._actionState = ActionStateEnum.Init;
        model.propertyErrorsComes = true;
      } else if (ord.NeedAcceptUri && ord.NeedAcceptProperty) {
        model._actionState = ActionStateEnum.Init;
        model.propertyErrorsComes = false;
      } else {
        model.propertyErrorsComes = false;
        model.OperationId = ord.operationId;
        model._actionState = ActionStateEnum.Confirm;
        model._isNeedConfirm = ord.needConfirm;
        model.IsNeedInfoBeforeExecute =
          ord.needInfoBeforeExecute || !ord.needConfirm;
      }

    } catch (e) {
      model.ActionStateText = e.message;
      await this.errorService.errorHandler(e, false, true, "");
    }
    return model;
  }

  /**
   * Обработка assign
   * @param name Имя параметра
   * @param model Данные операции
   */
  public async assign(
    name: string,
    model: CatalogOperationModel
  ): Promise<CatalogOperationModel> {
    try {
      let propertyData = model.Properties.find(
        (p: OperationPropertyModel) => {
          return p.Declaration.Name == name;
        }
      );

      if (!propertyData && !name.includes(';')) {
        return model;
      } else if (name.includes(';')) {
        const propName: string = name.split(';')[0]; 
        const subPropName: string = name.split(';')[2]; 
        propertyData = model.Properties.find(
          (p: OperationPropertyModel) => {
            return p.Declaration.Name == propName;
          }
        ); 
        propertyData = propertyData.SubProperties.find(
          (p: OperationPropertyModel) => {
            return p.Declaration.Name == subPropName;
          }
        );
        if (!propertyData)
          return model;
      }

      if (propertyData.check() === true) {
        model = await this.assignRequest(name, model);
      }

      if (model.RespondentCode === this.configStore.apiData.OperationCodeOfToOtherContractByCard) {
        const prop: OperationPropertyModel = model.Properties.find((prop: OperationPropertyModel) => prop.Declaration.Name == 'receiverName');
        if (prop) {
          if (prop.Value !== '' && prop.Value === 'Себе')
            prop.Declaration.Caption = i18n.t('common.transfer').toString();
          else if (prop.Value !== '' && prop.Value === 'Перевод на карту')
            prop.Declaration.Caption = i18n.t('common.transferType').toString();
          else
            prop.Declaration.Caption = i18n.t('main.contracts.bankDetails.RecepientName').toString();
        }
      }

    } catch (e) {
      model.ActionStateText = e.message;
      await this.errorService.errorHandler(e, false, true, "");
    }

    return model;
  }

  private async assignRequest(name: string, model: CatalogOperationModel): Promise<CatalogOperationModel> {
    let ord: OperationRequestData = await model.createOperationRequest();
    ord.assignProperty = name;
    try {
      ord = await OperationsApi.assignOperationSendAsync(ord);
    } catch(e: any) {
      // if (this.notCriticalErrors && this.notCriticalErrors.length) {
      //   if (!this.notCriticalErrors.filter((err: any) => e.message.includes(err)).length)
      //     router.go(-1);
      // }
      await this.errorService.errorHandler(e, false, true, "");
    }

    if(ord.message)
        await this.alertService.info(ord.message, false);

    model.setOperationFromRequest(ord, true);
    model.propertyErrorsComes = Object.keys(ord.PropertyErrors).length > 0;
    return model;
  }

  /**
   * Следующий шаг операции
   */
  public async nextStep(
    model: CatalogOperationModel
  ): Promise<CatalogOperationModel> {
    if (model.checkProperties()) {
      if (model.IsInit)
        model = (await this.prepare(model)) as CatalogOperationModel;
      else if (model.IsConfirm)
        model = (await this.execute(model)) as CatalogOperationModel;
    }
    return model;
  }

  /**
   * Действия после проведения операции
   * @param args
   */
  public async afterExecute(model: CatalogOperationModel): Promise<void> {
    if (model.IsSuccess) {
      if (
        this.configStore.apiData.OperationCodeOfOpenDeposit ==
        model.RespondentCode
      ) {
        this.contractsStore.fetchContracts();
      } else {
        const contractItem = model.Properties.find(
          (item: OperationPropertyModel) => {
            return item.Declaration.Name == "contract";
          }
        );
        const contractToItem = model.Properties.find(
          (item: OperationPropertyModel) => {
            return item.Declaration.Name == "contractTo";
          }
        );
        if (contractItem)
          this.contractsStore.updateContractByRefId(contractItem.Value.Key);

        if (contractToItem)
          this.contractsStore.updateContractByRefId(contractToItem.Value.Key);
      }
    }
  }
}
